import { render, staticRenderFns } from "./UserPreviewTable.vue?vue&type=template&id=4410d89c&scoped=true"
import script from "./UserPreviewTable.vue?vue&type=script&lang=js"
export * from "./UserPreviewTable.vue?vue&type=script&lang=js"
import style0 from "./UserPreviewTable.vue?vue&type=style&index=0&id=4410d89c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4410d89c",
  null
  
)

export default component.exports